import { render, staticRenderFns } from "./EndSession.vue?vue&type=template&id=205cf5a7&scoped=true&"
import script from "./EndSession.vue?vue&type=script&lang=ts&"
export * from "./EndSession.vue?vue&type=script&lang=ts&"
import style0 from "./EndSession.vue?vue&type=style&index=0&id=205cf5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205cf5a7",
  null
  
)

component.options.__file = "EndSession.vue"
export default component.exports